import { ConditionInterpreter, TokenType } from "@evergis/condition";
import { FilterConditionOperation, FilterConditionType } from "../../../components/LayerFilter/types";
import { createCondition, createConditionString } from "./createCondition";

export class FilterCondition {
  private readonly conditionInterpreter: ConditionInterpreter;

  constructor(private condition: string | null = null) {
    this.conditionInterpreter = new ConditionInterpreter(condition);
  }

  static from(conditions: FilterConditionType[], operation: FilterConditionOperation) {
    const condition = conditions?.map(createConditionString).join(` ${operation} `) || null;

    return new FilterCondition(condition);
  }

  get conditions(): FilterConditionType[] {
    const { value } = this.conditionInterpreter;

    if (value instanceof Error) {
      // TODO handle errors in client notifications
      console.warn(value.message);
    }

    return value instanceof Error ? [] : value.expressions.map(createCondition);
  }

  get conditionOperation() {
    const { value } = this.conditionInterpreter;

    if (value instanceof Error) {
      return null;
    }

    const isOrCondition = value.boolOperations.includes(TokenType.BoolOr);
    const isAndCondition = value.boolOperations.includes(TokenType.BoolAnd);

    if (isOrCondition && isAndCondition) {
      return null;
    }

    return isOrCondition ? FilterConditionOperation.OR : isAndCondition ? FilterConditionOperation.AND : null;
  }

  public isParsingError() {
    return this.conditionInterpreter.value instanceof Error;
  }

  public toString() {
    return this.condition;
  }
}
